import type { AppDefinition } from '../types';

/** Oracle — enterprise ERP. No connector yet. */
export const ORACLE_APP: AppDefinition = {
  id: 'oracle',
  nameKey: 'apps.oracle.name',
  descriptionKey: 'apps.oracle.description',
  logo: '/images/apps/oracle-logo.svg',
  categories: ['erp'],
  status: 'soon',
  label: 'soon',
};
